const moment          = require('moment')
moment().format()
const StoryblokClient = require('storyblok-js-client/dist/index.cjs')

const apiClient = () =>
  new StoryblokClient({ accessToken: process.env.VUE_APP_STORYBLOK_TOKEN })

module.exports = {
  async fetchStory (storyUrl, config = {}) {
    const response = await apiClient().get(`cdn/stories/${storyUrl}`, config)
    return response.data.story
  },
  async fetchDataSource (id) {
    const { data } = await apiClient().get(
      `cdn/datasource_entries?datasource=${id}&per_page=100&page=1`,
    )
    return data.datasource_entries
  },

  async fetchStoryList (startsWith, page = 1, perPage = 12, config = {}) {
    const now        = moment().format('YYYY-MM-DD HH:mm')
    const response   = await apiClient().get(`cdn/stories?filter_query[live_at][lt_date]=${now}&starts_with=${startsWith}&excluding_fields=body,Title,Description,NavBarVariant&is_startpage=0&per_page=${perPage}&page=${page}`)
    const totalPages = response.headers.total / perPage
    const data       = {
      stories: response.data.stories,
      pages  : Math.ceil(totalPages),
    }
    return data
  },
  async fetchAsset (id) {
    const response = await apiClient().get(`cdn/assets/${id}`)
    return response
  },
}
